export default __webpack_public_path__ + "static/media/business-model-canvas.44a7d939.svg";